import englishTranslations from "../translations/en";
import { Alert, Link, Typography } from "@mui/material";
export default function RenewalInfo() {
  return (
    <>
      {
        // nosemgrep
        process.env.LAPTOP_RENEWAL_ENABLED == "true" && (
          <Alert severity="info" sx={{ whiteSpace: "pre-line" }}>
            <Typography display={"inline"} color={"red"}>
              {"* "}
            </Typography>
            {englishTranslations.laptopRenewalInfo} If you have any questions,
            please refer to the{" "}
            <Link
              color="secondary.main"
              href={
                "https://docs.google.com/document/d/1MhlaYlzrOYhTytylI74zdNZSyKctPZTtM2WZBcxOShU/edit#heading=h.qsm85gjy199s"
              }
              target="_blank"
              rel="noreferrer"
              sx={{
                textDecoration: "none",
              }}
            >
              FAQs.
            </Link>
          </Alert>
        )
      }
    </>
  );
}
